import { useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider.tsx';
import { useMe } from '../lib/queries.ts';
import { devicePrefs } from '../lib/platform.ts';

export type ThemePref = 'system' | 'light' | 'dark';

/** Apply profile + device preferences to the document (motion, theme). */
export function PreferencesSync() {
  const { session } = useAuth();
  const me = useMe(Boolean(session));
  const motion = me.data?.profile.reducedMotion ?? 'system';

  useEffect(() => {
    const root = document.documentElement;
    if (motion === 'reduce') root.dataset.motion = 'reduce';
    else if (motion === 'no-preference') root.dataset.motion = 'full';
    else delete root.dataset.motion;
  }, [motion]);

  useEffect(() => applyTheme(devicePrefs.get<ThemePref>('theme', 'system')), []);
  return null;
}

export function applyTheme(pref: ThemePref): void {
  const root = document.documentElement;
  const dark = pref === 'dark' || (pref === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  root.dataset.theme = dark ? 'dark' : 'light';
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#12151d' : '#faf7f2');
}
